module.exports = __webpack_public_path__ + "static/bg-b4e4178b8552b1630f17252374782c8c.jpg";